// extracted by mini-css-extract-plugin
export default {"container-fluid":"Header_container-fluid__gFoqX","logo":"Header_logo__oxp7y","border":"Header_border__gETrX"};